/** @format */

declare global {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
        StyleMedia: any;
    }
}

/**
 * Returns whether or not a particular CSS property is supported
 *
 * @param {string} property
 */

// eslint-disable-next-line @mpb-com/mpb/boolean-function-prefix -- Legacy code: do not use as an example.
function supportsCSSProperty(property: string) {
    return typeof document !== 'undefined' && property in document.body.style;
}

/**
 * Checks if the browser is IE
 */

export function isIE() {
    return supportsCSSProperty('msFlex');
}
/**
 * Checks if the browser is Edge
 * @see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */

export function isEdge() {
    return !isIE() && typeof window !== 'undefined' && !!window.StyleMedia;
}
/**
 * Checks if the browser is Safari
 * @see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */

export function isSafari() {
    return (
        //@ts-ignore
        /constructor/i.test(window.HTMLElement) ||
        // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
        (function (p) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
            return p.toString() === '[object SafariRemoteNotification]';
        })(
            // @ts-ignore - Element implicitly has an any type - Touch and Change
            // eslint-disable-next-line @typescript-eslint/dot-notation -- Legacy code: do not use as an example.
            !window['safari'] ||
                //@ts-ignore
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
                (typeof safari !== 'undefined' && safari.pushNotification)
        )
    );
}
